export function countVotes(votes: { count: number }[]) {
  if (!votes) return 0;
  return votes.reduce((count, vote) => count + vote.count, 0);
}
